import { render, staticRenderFns } from "./FillingHeader.vue?vue&type=template&id=52204c40&scoped=true&"
import script from "./FillingHeader.vue?vue&type=script&lang=js&"
export * from "./FillingHeader.vue?vue&type=script&lang=js&"
import style0 from "./FillingHeader.vue?vue&type=style&index=0&id=52204c40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52204c40",
  null
  
)

export default component.exports